module.exports = __webpack_public_path__ + "media/location/hdrPhorography-8d12c8f6.png";